// extracted by mini-css-extract-plugin
export default {"component":"e3dz5"};